import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import EmployeeForm from "./employee-form";
import useEmployees from "hooks/useEmployees";
///
const NewEmployeeModal = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { isModalOpen, modalType, modalProps } = useSelector(
        (state) => state.modals
    );
    const { addEmployee, employee, setEmployee, isLoading, error, setError } = useEmployees();
    const [isSendForAdd, setIsSendForAdd] = useState(false);
    useEffect(() => {
        if (isSendForAdd) {
            if (error) {
                message.error(
                    t("employees.crud.form.error.add") + " " + error
                )
            } else {
                message.success(
                    t("employees.crud.form.add.success")
                )
                onClose();
            }
            setIsSendForAdd(false);
        }
    }, [isSendForAdd, error]);
    const open = isModalOpen && modalType === "new_employee";

  const onSubmit = async (values) => {
  setError(null);
  setIsSendForAdd(false);
  try {
    // Convertir les dates dayjs en format ISO
    const formattedValues = {
      ...values,
      salary:
        values.salary === undefined || values.salary === null || values.salary === ""
          ? values.salary
          : Number(values.salary),
      entryDate: values.entryDate.format('YYYY-MM-DD'),
      exitDate: values.exitDate?.format('YYYY-MM-DD') || null // Gestion de la date optionnelle
    };
    
    await addEmployee(formattedValues);
  } catch (error) {
    notification.error({
      message: t("employees.crud.form.error.add"),
      description: error,
      role: "alert",
      duration: 3,
    });
  } finally {
    setIsSendForAdd(true);
  }
};

    const onClose = () => {
        form.resetFields();
        dispatch(closeModal());
    };
    return (
        <Modal
            title={
                <h4 style={{ textAlign: "center" }}>{t("employees.crud.form")}</h4>
            }
            open={open}
            onCancel={onClose}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onClose} className="custom-btn-1">
                    {t("employees.crud.form.button.cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    form="employee_form"
                    disabled={isLoading}
                    className="custom-btn-2"
                >
                    {t("employees.crud.form.button.save")}
                </Button>,
            ]}
            centered
            styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
        >
            <EmployeeForm form={form} onSubmit={onSubmit} />
        </Modal>
    );
};

export default NewEmployeeModal;
